import React, { useRef } from "react";
import { Avatar, Typography, Stack, Popover } from "@mui/material";
import UserDetailsPanel from "./userDetailsCard";
import { UserClaimsService } from "../../../services/currentUserService/currentUserService";
import { useGetDemographicsByProfileKeyQuery } from "../../../services/cclTokenedEnterpriseCoachingApi";
import UserInfoMenuCard from "./userInfoMenuCard";

interface UserInfoPanelProps {}

const UserInfoPanel: React.FC<UserInfoPanelProps> = (props) => {
    const claimsService = new UserClaimsService();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [pic, setPic] = React.useState<string>(
        claimsService.GetCurrentUserPicture() ? claimsService.GetCurrentUserPicture() : ""
    );

    const name = claimsService.GetCurrentUserName() ?? "Unknown User";
    const pKey = claimsService.GetCurrentResourceId();
    const role = claimsService.GetCurrentUserGroup();
    const AssesmentAdminGroupName = claimsService.GetCurrentUserAssesmentAdminGroupName();

    const popoverRef = useRef<HTMLDivElement | null>(null);

    const { data: userData } = useGetDemographicsByProfileKeyQuery(pKey, { skip: !pKey });

    React.useEffect(() => {
        if (userData) {
            setPic(userData.profilePictureUrl);
        }
    }, [userData]);

    const handlePanelClick = (event: React.MouseEvent<HTMLDivElement>) => {
        if (anchorEl == null) {
            setAnchorEl(event.currentTarget);
        }
    };

    const handlePopoverClose = () => {
        if (anchorEl != null) {
            setAnchorEl(null);
        }
    };

    const handleShowSettings = () => {
        setAnchorEl(null); // Close popover after opening settings
    };

    const open = Boolean(anchorEl);

    return (
        <div onClick={handlePanelClick} style={{ cursor: "pointer" }}>
            <Stack direction="row" m={2}>
                <Stack marginRight={"7px"}>
                    <Typography variant="body2" marginLeft={"auto"}>
                        {name}
                    </Typography>
                    <Typography variant="body2" marginLeft={"auto"}>
                        {`${role} ${AssesmentAdminGroupName ? `- ${AssesmentAdminGroupName}` : ""}`}
                    </Typography>
                </Stack>
                <Avatar sx={{ display: { xs: "none", sm: "flex" } }} alt={name} src={pic}>
                    {name
                        .split(" ")
                        .map((n) => n[0])
                        .join("")
                        .toUpperCase()}
                </Avatar>
            </Stack>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                PaperProps={{
                    sx: {
                        backgroundColor: "#e1e1e1",
                        boxShadow: 3,
                        borderRadius: 2,
                        p: "6px",
                        minWidth: 300,
                    },
                    ref: popoverRef,
                }}
            >
                <UserDetailsPanel name={name} pic={pic} />
                <UserInfoMenuCard
                    onMenuClick={handleShowSettings}
                    popoverRef={popoverRef.current}
                />
            </Popover>
        </div>
    );
};

export default UserInfoPanel;
